import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminConsole from "./admin-console";
import UserDetails from "./users/user-details/user-details";

const AdminList = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminConsole />} />
      <Route path="/:id/details" element={<UserDetails />} />
    </Routes>
  );
};

export default AdminList;
